if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return
      this.form.querySelector('[name=id]').disabled = false;
      this.overlay = document.querySelector('[data-js-overlay-blur]');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // On gift card only, check if Email is filled and correct (mandatory), if not show error and stop the add to cart
      this.emailInput = this.form.querySelector('input[type="email"]')
      if(this.emailInput) {
        if(this.emailInput.value == '') {
          this.mailError = this.emailInput.dataset.valueEmpty
        } else if(!this.emailInput.value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
          this.mailError = this.emailInput.dataset.valueIncorrect
        } else {
          this.mailError = '';
        }

        if(this.mailError != '') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: new FormData(this.form).get('id'),
            message: this.mailError,
          });
          return;
        }
      }

      this.handleErrorMessage();
      this.clearCartLimitErrors();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
       
      // récupération des sections
      let sections = [...new Set(this.cart.getSectionsToRender().map((section) => section.id))]

      if (this.cart) {
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      // add loading on cart items 
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) {
        mainCartItems.classList.add('cart__items--disabled');
      }


       fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          // GESTION STATUS
          if (response.status) {
            this.handleErrorMessage(response.description);

            if (this.cart) {
              this.insertCartLimitError(formData.get('id'), response.description);
              this.cart.open();
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.error = true;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          };
          this.error = false;

          const responseObj = { ...response }; // Créez une copie de l'objet initial
      
          // VERIFICATION SECTIONS
          if (!response.sections) {   
            this.overlay.classList.add('is-active', '!u-z-60');
            document.querySelector('#cart').classList.add('is-visible');
            const cartDrawer = document.getElementById('CartDrawer');
            if (cartDrawer) {
              cartDrawer.classList.add('cart__items--disabled');
            }

            // Attendez le résultat du deuxième fetch
            const data = await fetch(window.location.pathname + `?sections=${sections.join(',')}`)
              .then((res) => res.json());
            responseObj.sections = data; // Modifiez l'objet ici

          }
          return responseObj; // Retournez l'objet mis à jour, ou inchangé si pas de fetch
        })
        .then((response) => {
          if (!response) return; // error case handled in previous .then()
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const cartDrawer = document.getElementById('CartDrawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('cart__items--disabled');
          }

          // remove loading on cart items
          const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
          if (mainCartItems) {

            mainCartItems.classList.remove('cart__items--disabled');
          }
          this.submitButton.classList.remove('loading');

          if (!this.error && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (!this.error) this.overlay.classList.add('is-active', '!u-z-60');

          // close exclusiv gift panel
          if (!this.error && this.dataset.gift) {

            // fermeture du panel des gift s'il est ouvert
            document.querySelector('#exclusivGift .c-sidebar__close').click()

          }
          // revive du product recommandation si on est en mobile et qu'on passe d'un cart vide à un cart plein
          if (!this.error) {
            localStorage.setItem('lastItemAdded', formData.get('product-id'))
            document.dispatchEvent(new CustomEvent('productRecommendations:revive', { detail: { container: document.querySelector('cart-drawer') }}));
          }

        });
    }

    insertCartLimitError(variantId, message) {
      const item = document.querySelector(`[data-pw-cart-item][data-id="${variantId}"]`);
      if (!item) return;
      this.clearCartLimitErrors();
      const el = document.createElement('p');
      el.dataset.cartLimitError = '';
      el.className = 'cart-limit-error';
      el.textContent = message;
      item.insertAdjacentElement('afterend', el);
    }

    clearCartLimitErrors() {
      document.querySelectorAll('[data-cart-limit-error]').forEach(el => el.remove());
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-product-form-recipient-error]');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
